import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  instanceId: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  getInstanceWithPassword: PropTypes.func.isRequired,
};

export function UnstyledShowPasswordIcon({
  classes,
  instanceId,
  instanceService,
  getInstanceWithPassword,
}) {
  const [passwordIsShowing, setPasswordIsShowing] = React.useState(false);

  const handleEyePoke = () => {
    getInstanceWithPassword(instanceId, instanceService, !passwordIsShowing).then((data) => {
      if (data.type === 'GET_INSTANCE_WITH_PASSWORD_SUCCESS') {
        setPasswordIsShowing(!passwordIsShowing);
      }
    });
  };

  if (instanceService.toLowerCase() !== 'redis') {
    return null;
  }

  if (passwordIsShowing) {
    return (
      <Icon className={classes.showPasswordIcon} onClick={handleEyePoke}>
        visibility_off
      </Icon>
    );
  }

  return (
    <Icon className={classes.showPasswordIcon} onClick={handleEyePoke}>
      visibility
    </Icon>
  );
}

UnstyledShowPasswordIcon.propTypes = propTypes;

const styles = () => ({
  showPasswordIcon: {
    cursor: 'pointer',
  },
});

export default withStyles(styles)(UnstyledShowPasswordIcon);
